import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import NewsCard from "@/components/feature/NewsCard";

export default function LatestNews() {
  const latest = news.slice(0, 4);

  return (
    <section className="bg-secondary-50 py-14 md:py-20">
      <div className="container-site">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-700">
              Latest News
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-3">
              最新动态
            </h2>
          </div>
          <Link
            to="/news"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:gap-3 transition-all whitespace-nowrap cursor-pointer"
          >
            浏览全部新闻
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mt-10">
          {latest.map((n) => (
            <NewsCard key={n.id} item={n} />
          ))}
        </div>
      </div>
    </section>
  );
}